/* eslint-disable no-console */
/**
 * Product and Policy API functions for fetching details
 */

import type { Policy } from '@/components/ecom-policy/types'
import { ecomPolicyResources } from '@/resources/ecom-policy'

import type { PolicyId } from './cart-types'

/**
 * Fetch policy details for multiple policy IDs in a single request
 *
 * @param ids Array of policy IDs to fetch
 * @returns Promise resolving to array of policies
 */
export const fetchPoliciesByIds = async (ids: PolicyId[]): Promise<Record<PolicyId, Policy>> => {
  if (ids.length === 0) {
    return {}
  }

  try {
    const promises = ids.map(id => ecomPolicyResources.get(Number(id)))

    const results = await Promise.all(promises)

    // Return a Record of policies by ID
    return Object.fromEntries(results.map(obj => [obj.id, obj]))
  } catch (error) {
    console.error('Failed to fetch policies:', error)
    throw error
  }
}
